
import { Options, Vue } from 'vue-class-component';

import { Button } from '@/components/Button';

@Options({
  components: {
    Button,
  },
})
export default class Home extends Vue {}
